/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIceJobV1JobEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ICE_JOB_V1_JOB_EVENT_ENTITY_NAME = 'exc.ice.job.v1.JobEvent';
export const excIceJobV1JobEventEntity = new schema.Entity<ExcIceJobV1JobEvent>(EXC_ICE_JOB_V1_JOB_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcIceJobV1JobEvent) => `${entity.metadata?.eventId}` });

